export default "__VITE_ASSET__90c05522__"